import React from 'react';
import { connect } from 'react-redux';

import NavigationDrawer from './NavigationDrawer';

import { selectIsAuthenticated } from '../../../../redux/auth/user/selectors';

const NavigationDrawerConnected = (props) => <NavigationDrawer {...props} />;

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
});

export default connect(mapStateToProps)(NavigationDrawerConnected);
